/* eslint-disable react/forbid-prop-types */
import React, {Component} from 'react';
import PropTypes from 'prop-types';

class KnowledgeCenterSidebar extends Component {

    static propTypes = {
        categories: PropTypes.object,
        textFilter: PropTypes.string,
        categoryFilter: PropTypes.array,
        keywords: PropTypes.array,
        keywordsSelected: PropTypes.array,
        handleChange: PropTypes.func,
        handleChangeOnClick: PropTypes.func,
        handleCategoryChange: PropTypes.func.isRequired,
        clearAll: PropTypes.func,
        displayClearAll: PropTypes.bool,
        toggleKeyword: PropTypes.func,
        textFilterType: PropTypes.string
    };

    static defaultProps = {
        textFilter: '',
        categoryFilter: [],
        keywords: [],
        keywordsSelected: [],
        categories: [],
        handleChange: () => {},
        handleChangeOnClick: () => {},
        toggleKeyword: () => {},
        textFilterType: 'input',
        displayClearAll: false,
        clearAll: () => {}
    };

    static getFilteredKeywords = (keywords) => {
        const allowed = [
            'emerging markets',
            'open trading',
            'regulation',
            'asia',
            'europe',
            'market data',
            'automation'
        ];

        return keywords.filter(keyword => allowed.includes(keyword.trim().toLowerCase()));
    };

    state = {
        categoryFilter: [],
        keywordsSelected: []
    };

    componentWillReceiveProps({categoryFilter, keywordsSelected}) {
        this.setState({...this.state, categoryFilter, keywordsSelected});
    }

    getKeywordTitle = keyword => {
        if (keyword === 'REGULATION') {
            return 'Regulation';
        }

        return keyword;
    };

    clearAll = () => {
        const {clearAll} = this.props;
        this.setState({keywordsSelected: [], categoryFilter: [], textFilter: ''});
        clearAll();
    };

    handleKeywordSelect = (e, keyword) => {
        const keywordsSelected = this.props.keywordsSelected;
        if (!keywordsSelected.includes(keyword)) {
            keywordsSelected.push(keyword);
        }
        this.setState({keywordsSelected});

        this.props.toggleKeyword(e, keyword);
    };

    handleCategoryFilterSelect = (e, category) => {
        const categoryFilter = this.props.categoryFilter;
        if (!categoryFilter.includes(category)) {
            categoryFilter.push(category);
        }
        this.setState({categoryFilter});

        this.props.handleCategoryChange(e, category);
    };

    render() {
        const {categories, textFilter, textFilterType, handleChange, handleChangeOnClick, displayClearAll} = this.props;

        const keywords = this.props.keywords ? KnowledgeCenterSidebar.getFilteredKeywords(this.props.keywords) : [];

        return (
            <aside className="knowledgeCenter__sideBar">

                <div className="knowledgeCenter__sideBarInner">

                    {textFilterType === 'input' && (
                        <div className="sideBar__search sideBar__search--onInput">
                            <input placeholder="Search by Title" type="text" value={textFilter} onChange={e => handleChange(e, 'textFilter')}/>
                        </div>
                    )}

                    {textFilterType === 'button' && (
                        <div className="sideBar__search sideBar__search--onSubmit">
                            <form onSubmit={(e) => {
                                e.preventDefault();
                                handleChangeOnClick(textFilter)
                            }}>
                                <input placeholder="Search by Title" type="text" value={textFilter} onChange={e => handleChange(e, 'textFilter')}/> <button type="submit" className="far fa-search"/>
                            </form>
                        </div>
                    )}

                    {keywords && keywords.length ? (
                        <div className="sideBar__filter">
                            <h3>Current Topics</h3>
                            <ul>
                                {keywords.filter(keyword => keyword).map(keyword => (
                                    <li key={`keyword_${keyword}`}>
                                        <input id={`filter-${keyword}`} type="checkbox" onClick={e => this.handleKeywordSelect(e, keyword)} checked={this.state.keywordsSelected.includes(keyword)}/>
                                        <label htmlFor={`filter-${keyword}`}>{this.getKeywordTitle(keyword)} <span className="fal fa-times" /></label>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ) : null}


                    <div className="sideBar__filter">
                        <h3>Content Format:</h3>
                        <ul>
                            {categories.filter(category => category).map(category => (
                                <li key={`category_${category}`}>
                                    <input id={`filter-${category}`} type="checkbox" onChange={(e) => this.handleCategoryFilterSelect(e, category)} checked={this.state.categoryFilter.includes(category)}/>
                                    <label htmlFor={`filter-${category}`}>{category} <span className="fal fa-times" /></label>
                                </li>
                            ))}
                        </ul>
                    </div>


                    {displayClearAll ? (
                        <div className="sideBar__clear">
                            <button onClick={() => this.clearAll()} className="button button--primary">Clear All</button>
                        </div>
                    ) : null}

                </div>

            </aside>
        );
    }
}

export default KnowledgeCenterSidebar;



// WEBPACK FOOTER //
// ./frontend/components/KnowledgeCenter/KnowledgeCenterSidebar.jsx